import { render, staticRenderFns } from "./MessageTemplateListCard.vue?vue&type=template&id=92f8e3aa"
import script from "./MessageTemplateListCard.vue?vue&type=script&lang=ts"
export * from "./MessageTemplateListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports